import $ from 'jquery';
import initSectionModels from './model';
import productNativeVideo from './native-video-player';
import embedYoutube from './youtube-player';
import isTouch from '../exports/touch-detect';
import isTouchDevice from '../exports/touch-detect';

var selectors = {
  productSlideshow: '[data-product-slideshow]',
  productThumbs: '[data-product-thumbs]',
  productImage: '[data-product-image]',
  mediaSlide: '[data-media-slide]',
  videoPlayerExternal: '[data-type="external_video"]',
  videoPlayerNative: '[data-type="video"]',
  modelViewer: '[data-type="model"]',
  allPlayers: '[data-player]',
  xrButton: '[data-shopify-xr]',
  xrButtonId: 'data-shopify-model3d-id',
};

var thumbIcons = {
  model:
    '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-media-model" viewBox="0 0 26 26"><path d="M1 25h24V1H1z"/><path class="icon-media-model-outline" d="M.5 25v.5h25V.5H.5z" fill="none"/><path class="icon-media-model-element" d="M19.13 8.28L14 5.32a2 2 0 0 0-2 0l-5.12 3a2 2 0 0 0-1 1.76V16a2 2 0 0 0 1 1.76l5.12 3a2 2 0 0 0 2 0l5.12-3a2 2 0 0 0 1-1.76v-6a2 2 0 0 0-.99-1.72zm-6.4 11.1l-5.12-3a.53.53 0 0 1-.26-.38v-6a.53.53 0 0 1 .27-.46l5.12-3a.53.53 0 0 1 .53 0l5.12 3-4.72 2.68a1.33 1.33 0 0 0-.67 1.2v6a.53.53 0 0 1-.26 0z" opacity=".6" style="isolation:isolate"/></svg>',
  video:
    '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-media-video" viewBox="0 0 26 26"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 25h24V1H1v24z"/><path class="icon-media-video-outline" d="M.5 25v.5h25V.5H.5V25z"/><path class="icon-media-video-element" fill-rule="evenodd" clip-rule="evenodd" d="M9.718 6.72a1 1 0 0 0-1.518.855v10.736a1 1 0 0 0 1.562.827l8.35-5.677a1 1 0 0 0-.044-1.682l-8.35-5.06z" opacity=".6"/></svg>',
  external_video:
    '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-media-video" viewBox="0 0 26 26"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 25h24V1H1v24z"/><path class="icon-media-video-outline" d="M.5 25v.5h25V.5H.5V25z"/><path class="icon-media-video-element" fill-rule="evenodd" clip-rule="evenodd" d="M9.718 6.72a1 1 0 0 0-1.518.855v10.736a1 1 0 0 0 1.562.827l8.35-5.677a1 1 0 0 0-.044-1.682l-8.35-5.06z" opacity=".6"/></svg>',
};

var initMedia;
var destroyMedia;
var filterMedia;

class Media {
  constructor(section) {
    this.section = section;
    this.$container = $(section.container);
    this.selectors = selectors;

    this.initMedia = this.init;
    this.destroyMedia = this.destroy;

    this.filterMedia = this.filter;
  }
  init() {
    this.detectVideo();
    this.detectYouTube();
    this.detect3d();
    this.createSlider();
  }
  reinit( values ) {
    let $productSlideshow = $(selectors.productSlideshow, this.$container),
        productMediaItemsHtml = $('[product-media-items-object]', this.$container).html(),
        $productMediaItems = $(productMediaItemsHtml);

    this.destroyMedia();

    // Dynamic slider - delete all media, construct again from json object and reinit
    $productSlideshow.html('');

    // console.log( {
    //   "values": values,
    //   "productMediaItemsHtml": productMediaItemsHtml,
    //   "$productMediaItems": $productMediaItems,
    // } );

    if( values == undefined ) {
      // Build the slider html with all slides if this is a simple product
      $productSlideshow.html( $productMediaItems );
    } else {
      for( let i=0 ; i<values.length ; i++ ) {
        let value = values[i],
            $filteredMediaItems = $productMediaItems.filter(`[data-alt="${value}"]`);
        $productSlideshow.append( $filteredMediaItems );
      }
    }

    this.initMedia();
  }
  createSlider() {
    var instance = this;
    const $slideshow = $(selectors.productSlideshow, this.$container);

    $slideshow
      .on('beforeChange', function(event, slick, currentSlide) {
        const $currentMedia = $(slick.$slides[currentSlide]).find(selectors.mediaSlide);
        $currentMedia.trigger('pause');
      })

      .on('afterChange', function(event, slick, currentSlide) {
        const $currentMedia = $(slick.$slides[currentSlide]).find(selectors.mediaSlide);
        const mediaType = $currentMedia[0].dataset.type;
        const isFocusEnabled = $('body').hasClass('focus-enabled');
        $currentMedia.trigger('play-desktop');
        // disable swipe on 3d models and videos
        if (mediaType === 'image' && isTouch()) {
          // fisrt boolean sets value, second option false to prevent refresh
          // slick.slickSetOption('swipe', true, false);
        } else {
          // slick.slickSetOption('swipe', false, false);
        }

        if (mediaType === 'model') {
          // change button to launch new model
          var newModel = $currentMedia[0].dataset.mediaId;
          $(selectors.xrButton, instance.container).attr(selectors.xrButtonId, newModel);
        }

        // slick bug, don't hide inactive thumbs from tab-through
        $('.slick-dots li', this.$container).attr('aria-hidden', false);

        if (isFocusEnabled) {
          $currentMedia.focus();
        }
      })

      .on('init', function(event, slick) {
        $(selectors.mediaSlide, this.$container).each(function(){
          let alt = $(this).attr("data-alt");
          $(this).closest('.slick-slide').attr('data-alt', alt);
        });

        // if the first element is a model or video, disable swipe
        var firstType = $(slick.$slides[0]).find(selectors.mediaSlide)[0].dataset.type;
        const $productThumbImages = instance.$container.find('[data-thumbnail]');

        // slick bug, don't hide inactive thumbs from tab-through
        $('.slick-dots li', this.$container).attr('aria-hidden', false);

        // Only swipe on image slides when screen is small
        if (firstType === 'image' && window.innerWidth < 768) {
          // slick.slickSetOption('swipe', true, false);
        }

        $productThumbImages
          .on('click', function(e) {
            e.preventDefault();
          })
          .on('keyup', function(e) {
            // On keypress Enter move the focus to the first focusable element in the related slide
            if (e.keyCode === 13) {
              var mediaId = $(this).data('media-id');
              $(slick.$slides)
                .filter(`[data-media-id="${mediaId}"]`)
                .find('model-viewer, video, iframe')
                .eq(0)
                .focus()
                .select();
            }
          });
      })

      .slick({
        focusOnSelect: true,
        adaptiveHeight: true,
        dots: true,
        arrows: false,
        accessibility: false,
        // fade: (isTouch() ? false : true),
        // swipe: (isTouch() ? true : false),
        swipe: true,
        speed: 300,
        // cssEase: 'linear',
        // eslint-disable-next-line
        appendDots: $(selectors.productThumbs, this.$container),
        customPaging: function(slider, i) {
          var $media = $(slider.$slides[i]).find(selectors.mediaSlide);
          var type = $media.data('type');
          var mediaId = $media.data('media-id');
          var thumb = $media.data('thumb');
          var thumbAlt = $media.attr('aria-label');
          var thumbIcon = thumbIcons[type] ? thumbIcons[type] : '';
          var tag = `<span _href="${thumb}" class="thumb--${type}" data-thumbnail data-media-id="${mediaId}">
              <img alt="${thumbAlt}" src="${thumb}">${thumbIcon}
             </span>`;
          return tag;
        },
      });
  }
  detect3d() {
    var $modelViewerElements = $(selectors.modelViewer, this.$container);
    if ($modelViewerElements.length) {
      initSectionModels($modelViewerElements, this.section.id);
      const instance = this;
      $(document).on('shopify_xr_launch', function() {
        $(selectors.allPlayers, instance.container).trigger('pause');
      });
    }
  }
  detectVideo() {
    const playerElements = this.section.container.querySelectorAll(selectors.videoPlayerNative);
    for (var player of playerElements) {
      const uniqueKey = player.dataset.player;
      const nativePlayerPromise = productNativeVideo(uniqueKey);
      if (this.section.settings.enable_video_looping === true) {
        nativePlayerPromise.then((nativePlayer) => {
          nativePlayer.loop = true;
          return nativePlayer;
        }).catch((err) => {
          console.error(err);
        });
      }
    }
  }
  detectYouTube() {
    const playerElements = this.section.container.querySelectorAll(selectors.videoPlayerExternal);
    for (var player of playerElements) {
      const uniqueKey = player.dataset.player;
      const youtubePlayerPromise = embedYoutube(uniqueKey);
      if (this.section.settings.enable_video_looping === true) {
        youtubePlayerPromise.then((youtubePlayer) => {
          return _setToLoop(youtubePlayer);
        }).catch((err) => {
          console.error(err);
        });
      }
    }
  }
  pauseOtherMedia(uniqueKey) {
    const $currentMedia = $(`[data-media-slide][data-player="${uniqueKey}"]`, this.container);
    const $otherMedia = $('[data-media-slide]').not($currentMedia);
    $otherMedia.trigger('pause');
  }
  destroy() {
    $(selectors.productSlideshow, this.$container).slick('unslick');
    $('[data-player]', this.container).trigger('destroy');
  }
}

function _setToLoop(youtubePlayer) {
  youtubePlayer.addEventListener('onStateChange', function(event) {
    if (event.data === 0) {
      // video is over, replay
      event.target.playVideo();
    }
  });
  return youtubePlayer;
}

export default Media;
